import "iframe-resizer/js/iframeResizer.contentWindow.min.js";
import "react-app-polyfill/ie11";
import "react-app-polyfill/stable";
import "./index.css";
import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import * as serviceWorker from "./serviceWorker";
import { ThemeProvider as MuiThemeProvider, createTheme, StyledEngineProvider } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";
// Import the legacy ThemeProvider for @mui/styles
import { ThemeProvider as LegacyThemeProvider } from "@mui/styles";

const theme = createTheme();

ReactDOM.render(
  <React.StrictMode>
    <StyledEngineProvider injectFirst>
      {/* MuiThemeProvider for new components */}
      <MuiThemeProvider theme={theme}>
        {/* LegacyThemeProvider for legacy @mui/styles */}
        <LegacyThemeProvider theme={theme}>
          <CssBaseline />
          <App />
        </LegacyThemeProvider>
      </MuiThemeProvider>
    </StyledEngineProvider>
  </React.StrictMode>,
  document.getElementById("root")
);

serviceWorker.unregister();